import * as React from 'react'

export const PrintsIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M3.5 5H2V2C2 0.90625 2.875 0 4 0H11.1562C11.6875 0 12.1875 0.21875 12.5625 0.59375L13.4062 1.4375C13.7812 1.8125 14 2.3125 14 2.84375V5H12.5V2.84375C12.5 2.71875 12.4375 2.59375 12.3438 2.5L11.5 1.65625C11.4062 1.5625 11.2812 1.5 11.1562 1.5H4C3.71875 1.5 3.5 1.75 3.5 2V5ZM4 11.5V14.5H12V11.5H4ZM3.5 10H12.5C13.0312 10 13.5 10.4688 13.5 11H14.5V8C14.5 7.75 14.25 7.5 14 7.5H2C1.71875 7.5 1.5 7.75 1.5 8V11H2.5C2.5 10.4688 2.9375 10 3.5 10ZM13.5 12.5V15C13.5 15.5625 13.0312 16 12.5 16H3.5C2.9375 16 2.5 15.5625 2.5 15V12.5H1C0.4375 12.5 0 12.0625 0 11.5V8C0 6.90625 0.875 6 2 6H14C15.0938 6 16 6.90625 16 8V11.5C16 12.0625 15.5312 12.5 15 12.5H13.5Z"
        fill="currentColor"
      />
    </svg>
  )
}
